import { css } from "@emotion/react";

/** Creates a flex parent that centers content horizontally. */
export const flexHorizontalCenter = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

/** Creates a flex parent that pushes row contents apart from each other */
export const flexApart = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/** Creates a flex parent that pushes all row contents to the right */
export const flexRight = css`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
`;

/** Creates a flex parent that centers content on both axises. */
export const flexMiddle = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const fixedFullSize = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

/** Center CTA and limit width to 400px. */
export const ctaStyles = css`
  max-width: 400px;
  margin: 0 auto;
`;
